<template>
  <div
    v-if="open"
    class="dacb-settings-panel"
    :class="{ '-mobile': mobileMode }"
    :style="{ backgroundColor: options.primaryColour }"
  >
    <div classnsd="dacb-chat-header">
      <span class="dacb-title">
        <p>{{ $t("chatSettings") }}</p>
      </span>
    </div>

    <ul class="-middle">
      <li>
        <form class="name-form" @submit.prevent="changeName">
          <input v-model="name" type="text" />
          <action-button :text="changeNameText" :state="changeNameState" @pressed="changeName" />
        </form>
      </li>
    </ul>

    <ul class="-bottom">
      <li>
        <form @submit.prevent="clearData">
          <action-button :text="clearDataText" class="-danger" :state="clearDataState" @pressed="clearData" />
        </form>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";

import ActionButton from "@/components/ActionButton.vue";
import bus from "@/helpers/bus";
import validators from "@/helpers/validators";

export default {
  name: "SettingsPanel",

  components: { ActionButton },

  props: {
    open: {
      type: Boolean,
      default: false
    }
  },

  emits: ["close"],

  data() {
    return {
      name: "",
      changeNameState: "normal",
      clearDataState: "normal",
      changeNameText: this.$t("changeName"),
      clearDataText: this.$t("clearData")
    };
  },

  computed: {
    ...mapState({
      options: (state) => state.options.options,
      customer: (state) => state.customer.current,
      conversation: (state) => state.conversation.current,
      mobileMode: (state) => state.settings.mobileMode
    })
  },

  watch: {
    open() {
      bus.$emit("connectPusher");
      this.name = this.customer.name;
    }
  },

  created() {
    bus.$on("dataCleared", this.handleDataCleared);
  },

  unmounted() {
    bus.$off("dataCleared", this.handleDataCleared);
  },

  methods: {
    handleDataCleared() {
      this.clearDataState = "normal";
      this.close();
    },

    changeName() {
      // Ensure valid name
      if (!validators.validateName(this.name)) return;

      // Ensure not already submitting
      if (this.changeNameState !== "normal") return;
      this.changeNameState = "loading";

      // Do update
      this.$store
        .dispatch("updateCustomerName", {
          name: this.name,
          conversation_id: this.conversation.id,
          skip_response: true
        })
        .then(() => {
          this.changeNameState = "done";
          setTimeout(() => {
            this.changeNameState = "normal";
            this.close();
          }, 1000);
        })
        .catch((err) => {
          this.changeNameState = "normal";
          console.error("error updating name", err);
        });
    },

    clearData() {
      if (this.clearDataState !== "normal") return;
      this.clearDataState = "loading";

      setTimeout(() => {
        if (confirm(this.$t("areYouSure"))) {
          // Pusher event triggers on success, see App.vue
          this.$store.dispatch("deleteCustomer").then(() => {
            this.clearDataState = "done";
            setTimeout(() => {
              this.clearDataState = "normal";
              this.close();
            }, 1000);
          });

          // Cancelled clear data
        } else {
          this.clearDataState = "normal";
        }
      }, 100);
    },

    close() {
      this.$emit("close");
    }
  }
};
</script>
